export const DELETE_MODE = {
    ALL: "ALL",
    BULK: "BULK"
}

export const UNAUTHORIZED_ACCESS = "The user is not authorized to access this Page";

export const EndPoints = {
  Admin: { READ: 1001, WRITE: 1002 },
  Roles: { READ: 2001, WRITE: 2002 },
  Users: { READ: 3001, WRITE: 3002 },
  Subscription: { READ: 4001, WRITE: 4002 },
  Course: { READ: 5001, WRITE: 5002 },
  Template: { READ: 6001, WRITE: 6002 },
  Dashboard: { READ: 7001, WRITE: 7002 },
};